import React, { Component } from 'react';
import uploadcare from 'uploadcare-widget';
import PropTypes from 'prop-types';

class Uploader extends Component {
  static propTypes = {
    validateUpload: PropTypes.func,
    onLoading: PropTypes.func,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    crop: PropTypes.string,
    tabs: PropTypes.instanceOf(Array),
    onChange: PropTypes.func,
    icon: PropTypes.element,
    className: PropTypes.string,
    imagesOnly: PropTypes.bool,
    multiple: PropTypes.bool,
    style: PropTypes.instanceOf(Object),
    customLoading: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  };

  static defaultProps = {
    onLoading: () => {},
    style: {},
    label: false,
    multiple: false,
    imagesOnly: false,
    crop: 'free',
    icon: <i className="fas fa-camera d-inline-block mr-2" />,
    tabs: ['file', 'url'],
    validateUpload: () => {},
    onChange: () => {},
    className: 'btn btn-primary cms-bg-color-primary cms-outline-primary ',
    customLoading: false,
  };

  state = {
    isUploading: false,
    progress: 0,
  };

  imagesOnly = (fileInfo) => {
    const { isImage, mimeType } = fileInfo;
    const { validateUpload } = this.props;
    if (isImage === false) {
      validateUpload();
      this.setState({
        isUploading: false,
        progress: 0,
      });
      throw new Error('image');
    }

    if (['image/gif'].indexOf(mimeType) > -1) {
      validateUpload();
      this.setState({
        isUploading: false,
        progress: 0,
      });
      throw new Error('image');
    }
  };

  handleUpload = (e) => {
    e.preventDefault();
    const { tabs, onLoading, crop, multiple, imagesOnly } = this.props;
    const { isUploading } = this.state;

    if (isUploading) {
      return;
    }

    uploadcare
      .openDialog(null, {
        publicKey: process.env.REACT_APP_UPLOADCARE_KEY,
        tabs,
        crop,
        multiple,
        imagesOnly,
        validators: imagesOnly ? [this.imagesOnly] : '',
      })
      .done((file) => {
        // file.promise().progress(this.handleProgress).done(this.handleDone);
        onLoading(true);
        // file.files().forEach((d) => {
        //   d.progress(this.handleProgress).done(this.handleDone);
        // });
        file.progress(this.handleProgress).done(this.handleDone);
      });
  };

  handleDone = (data) => {
    const { onChange } = this.props;
    onChange(data);
  };

  handleProgress = ({ state, progress }) => {
    const { onLoading } = this.props;
    if (state === 'uploading') {
      this.setState({
        isUploading: true,
        progress: Math.ceil(progress * 100),
      });
    }
    if (state === 'uploaded') {
      this.setState({
        isUploading: true,
        progress: 100,
      });
    }

    if (state === 'ready') {
      onLoading(false);
      this.setState({
        isUploading: false,
        progress: 0,
      });
    }
  };

  render() {
    const { className, label, icon, style, customLoading } = this.props;
    const { isUploading, progress, btnCaption } = this.state;
    const Progress = () => {
      if (isUploading) {
        return <span>({progress}%)...</span>;
      }
      return <span />;
    };

    return (
      <button
        type="button"
        id="uploaded_photo"
        onClick={this.handleUpload}
        className={className}
        style={style}
      >
        {customLoading ? (
          <>{isUploading ? customLoading : icon}</>
        ) : (
          <>
            {icon}
            {isUploading ? (
              <Progress />
            ) : (
              !label && (
                <div className="d-inline-block">{btnCaption || label}</div>
              )
            )}
          </>
        )}
      </button>
    );
  }
}

export default Uploader;
